import {useEffect, useState} from "react";
import {useActions} from "./index";


export default function useCategories() {
  const actions = useActions();
  const [items, setItems] = useState([]);
  // const items = [
  //   {
  //     id: 1,
  //     title: 'Category 1',
  //     items: [
  //       {id: 1, title: 'Product 1', width: 100, height: 150, depth: 10, price: 120},
  //       {id: 2, title: 'Product 2', width: 85, height: 125, depth: 8, price: 106},
  //     ]
  //   },
  //   {
  //     id: 2,
  //     title: 'Category 2',
  //     items: [
  //       {id: 3, title: 'Product 3', width: 100, height: 150, depth: 30, price: 169},
  //       {id: 4, title: 'Product 4', width: 85, height: 125, depth: 25, price: 219},
  //     ]
  //   },
  // ];


  useEffect(() => {
    actions.getCategories()
      .then(res => {
        if(res.status === 'success') {
          setItems(res.data);
        }
      })
      .catch(err => {
        console.error(err)
      })
  }, [])


  return {
    items,
  }
}